import React, { useState, useEffect } from "react";
import "./styles.css";

const SecondQuestionFormComponent = ({
  questionResponse,
  questions,
  onChangeQuestions,
  setShowErrorModal,
}) => {
  const [showTextArea, setShowTextArea] = useState(false);

  useEffect(() => {
    if (questions.q1.response === "Otros") {
      setShowTextArea(true);
    }
  }, []);

  const onClickNextQuestion = () => {
    if (
      ((questions.q1.response === "Otros" &&
        questions.q1.observations !== "") ||
        (questions.q1.response !== "Otros" &&
          questions.q1.observations === "")) &&
      questions.q2.response !== ""
    ) {
      questionResponse(3);
    } else {
      setShowErrorModal(true);
    }
  };

  const onClickRadio = (event, reason) => {
    if (
      event.type === "click" ||
      (event.type === "change" && event.target.id === "optionOtrosTextArea")
    ) {
      const id = event.target.id;
      let name = "";
      let question = "";
      let observations = "";
      if (id === "optionOtros" || id === "optionOtrosTextArea") {
        setShowTextArea(true);
      } else {
        setShowTextArea(false);
      }
      if (id === "optionGoogle") {
        name = "Google";
      } else if (id === "optionFacebook") {
        name = "Facebook";
      } else if (id === "optionInstagram") {
        name = "Instagram";
      } else if (id === "optionDoctoralia") {
        name = "Doctoralia";
      } else if (id === "optionOtros") {
        name = "Otros";
      } else if (id === "optionOtrosTextArea") {
        observations = event.target.value;
        name = "Otros";
      }
      question = "q1";
      const updatedQuestions = {
        ...questions,
        [question]: {
          response: name,
          observations: observations,
        },
      };
      onChangeQuestions(updatedQuestions, question);
    } else if (event.type === "change" && reason) {
      let question = "q2";
      const reasonText = event.target.value;
      const updatedQuestions = {
        ...questions,
        [question]: {
          response: reasonText,
          observations: "",
        },
      };
      onChangeQuestions(updatedQuestions, question);
    }
  };

  return (
    <div className="secondQuestionFormComponent">
      <div className="contentQuestion">
        <p>¿Cómo nos ha conocido?</p>
        <div className="contentRadioButtons">
          <label htmlFor="optionGoogle">
            <input
              type="radio"
              id="optionGoogle"
              name="check"
              defaultChecked={questions.q1.response === "Google"}
              onClick={(event) => onClickRadio(event, false)}
            />
            Google
          </label>
          <label htmlFor="optionFacebook">
            <input
              type="radio"
              id="optionFacebook"
              name="check"
              defaultChecked={questions.q1.response === "Facebook"}
              onClick={(event) => onClickRadio(event, false)}
            />
            Facebook
          </label>
          <label htmlFor="optionInstagram">
            <input
              type="radio"
              id="optionInstagram"
              name="check"
              defaultChecked={questions.q1.response === "Instagram"}
              onClick={(event) => onClickRadio(event, false)}
            />
            Instagram
          </label>
          <label htmlFor="optionDoctoralia">
            <input
              type="radio"
              id="optionDoctoralia"
              name="check"
              defaultChecked={questions.q1.response === "Doctoralia"}
              onClick={(event) => onClickRadio(event, false)}
            />
            Doctoralia
          </label>
          <label htmlFor="optionOtros">
            <input
              type="radio"
              id="optionOtros"
              name="check"
              defaultChecked={questions.q1.response === "Otros"}
              onClick={(event) => onClickRadio(event, false)}
            />
            Otros
          </label>
        </div>
        {showTextArea && (
          <div className="appointmentConsultationPopUp">
            <textarea
              className="textAreaAppointmentConsultation"
              id="optionOtrosTextArea"
              value={questions.q1.observations}
              onChange={(event) => onClickRadio(event, false)}
            />
          </div>
        )}
        <div className="appointmentConsultation">
          <p>¿Cuál es el motivo de la consulta?</p>
          <textarea
            className="textAreaAppointmentConsultation"
            id="reasonTextArea"
            value={questions.q2.response}
            onChange={(event) => onClickRadio(event, true)}
          />
        </div>
        <div className="containerButtonsForm">
          <button className="btnForm" onClick={onClickNextQuestion}>
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecondQuestionFormComponent;
